const DEFAULT_INTERVAL = ' ';

export class AddressMap {
  constructor(args) {
    const mappedArgs = args.map(item => [item[0].join(DEFAULT_INTERVAL), item[1]]);
    this.map = new Map(mappedArgs);
  }

  set(coords, value) {
    return this.map.set(coords.join(DEFAULT_INTERVAL), value);
  }

  get(coords) {
    return this.map.get(coords.join(DEFAULT_INTERVAL));
  }
}